'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { useFeatureFlagEnabled, usePostHog } from '@posthog/react';
import { useEffect, useState } from 'react';
import { shouldForceEnableFeatureFlags } from './feature-flag-environment';

export function resolvePostHogBoolFlag(
  isEnabled: boolean | undefined,
  hasLoadedFlags: boolean,
  defaultValue?: boolean
): boolean | undefined {
  if (defaultValue !== undefined) return isEnabled ?? defaultValue;
  if (isEnabled === true) return true;
  if (!hasLoadedFlags) return undefined;
  return false;
}

export function usePostHogFlagsReady(): boolean {
  const posthog = usePostHog();
  const areFlagsForcedOn = shouldForceEnableFeatureFlags();
  const [isReady, setIsReady] = useState(
    () => areFlagsForcedOn || Boolean(posthog?.featureFlags?.hasLoadedFlags)
  );

  useEffect(() => {
    if (areFlagsForcedOn) return undefined;
    if (!posthog) return undefined;
    if (posthog.featureFlags?.hasLoadedFlags) setIsReady(true);

    return posthog.onFeatureFlags(() => {
      setIsReady(true);
    });
  }, [areFlagsForcedOn, posthog]);

  return areFlagsForcedOn || isReady;
}

export function usePostHogBoolFlag(flagKey: string): boolean | undefined;
export function usePostHogBoolFlag(flagKey: string, defaultValue: boolean): boolean;
export function usePostHogBoolFlag(flagKey: string, defaultValue?: boolean): boolean | undefined {
  const isEnabled = useFeatureFlagEnabled(flagKey);
  const hasLoadedFlags = usePostHogFlagsReady();
  if (shouldForceEnableFeatureFlags()) return true;
  return resolvePostHogBoolFlag(isEnabled, hasLoadedFlags, defaultValue);
}
